<template>
    <div class="vuetable">
        <vuetable ref="vuetable"
            :fields="tableFields"
            :api-mode="false"
            :per-page="perPageA"
            :data-manager="dataManager"
            :sort-order="defaultSortOrder"
            :tablePagination ="page"
            :row-class="onRowClass"
            :track-by="trackBy"
            :css="css.table"
            pagination-path="pagination"
            @vuetable:row-clicked="clicked"
            @vuetable:pagination-data="onPaginationData"
            @vuetable:loaded="changes1">

            <div v-if="slots" v-for="slot in slots" :key="slot.name" :slot="slot.name" :class="slot.class ? slot.class : 'middle'" slot-scope="props">
                <slot :name="slot.name" :data="props.rowData" :index="props.rowIndex"></slot>
            </div>
            <template v-if="useSearch" slot="tableHeader">
                <template>
                    <tr v-if="Object.keys(filters).length > 0">
                        <th :useBulk="useBulk" class="middle"><slot name="bulk"></slot></th>
                        <th class="search-field" v-for="(property, index) in Object.keys(filters)" v-bind:key="index">
                            <input v-on:keyup="onSearch($event.target)" :name="property" :placeholder="filters[property].placeholder"
                            type="text" class="form-control" v-model="filters[property].value">
                        </th>
                    </tr>
                </template>
                <vuetable-row-header></vuetable-row-header>
            </template>
        </vuetable>
        <div class="vuetable-pagination" :class="{ 'hidden': showPag }">
            <div class="row">
              <div class="col-6">
                <div class="selecter d-none" v-if="limitOptions.length">
                  <select v-model="perPageA" class="form-control">
                    <option v-for="limitOption in limitOptions" :value="limitOption.value">{{limitOption.name}}</option>
                  </select>
                </div>
              </div>
              <div class="col-6">
                <table-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></table-pagination>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import slice from 'lodash.slice';
import orderBy from 'lodash.orderby';
import Vuetable from 'vuetable-2';
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
import VuetableRowHeader from 'vuetable-2/src/components/VuetableRowHeader.vue';
import _ from 'underscore';
import TableStyles from './TableStyles';
import TablePagination from './TablePagination';
import { mapGetters } from 'vuex';

export default {
    name: 'vue-table',
    props: {
        slots: {
            type: Array,
            default: () => {
                return [
                    {name: 'actions'}
                ];
            }
        },
        trackBy: {
          type: String,
          default: 'id'
        },
        dataTable: {
            type: Array,
            default: () => {
                return [];
            }
        },
        perPage: {
            type: Number,
            default: 10
        },
        tableFields: {
            type: Array,
            default: () => {
                return [];
            }
        },
        useSearch: {
            type: Boolean,
            default: false
        },
        useBulk: {
            type: Boolean,
            default: false
        },
        defaultSortOrder: {
            type: Array,
            default: () => {
                return [];
            }
        },
        filters: {
            type: Object,
            default: () => {
                return {};
            }
        },
        selectedRows: {
            type: Array,
            default: () => {
                return [];
            }
        },
        page: {
            type: Number,
            default: 1
        },
        //TBD
        testCubesStatus: {
            type: Boolean,
            default: false
        },
        onRowClass: {
            type: Function,
            default: () => {}
        }
    },
    data () {
        return {
            css: TableStyles,
            showPag: false,
            limitOptions: [],
            perPageA: 10,
            cubesStatusIntervalId: null
        };
    },
    components: {
        Vuetable,
        VuetablePagination,
        TablePagination,
        VuetableRowHeader
    },
    watch: {
        perPage (newVal, oldVal){
            this.perPageA = newVal;
        },
        dataTable (newVal, oldVal) {
            this.generateOptions(newVal.length);
            this.$refs.vuetable.refresh();
        },
        page (newVal, oldVal) {
            this.onPaginationData(newVal);
            this.onChangePage(newVal);
        }
    },
    mounted () {
        this.onPaginationData(this.page);
        this.onChangePage(this.page);
        this.$refs.vuetable.refresh();
    },
    beforeDestroy () {
        if(this.cubesStatusIntervalId) {
            clearInterval(this.cubesStatusIntervalId);
        }
    },
    //USUNAC TO WSZYSTKO TO NIE TO MIEJSCE
    computed:{
        ...mapGetters({ cubes: 'getCubes', cubesStatus: 'getCubesStatus', pageVuex: 'getShopsTablePage', } )
    },
    //
    methods: {
        //USUNAC TO WSZYSTKO TO NIE TO MIEJSCE
        changes1 () {
            if(!this.testCubesStatus) {
                this.$emit('currentData', this.$refs.vuetable.tableData);
                return;
            }

            this.reciveCubesStatus();
            this.$emit('currentData', this.$refs.vuetable.tableData);
        },
        reciveCubesStatus () {//BZDURA !!!!
            //get data
            for (let row of this.$refs.vuetable.tableData) {
                if(this.cubes[row.id] && this.cubes[row.id].list) {
                    for(let cube of this.cubes[row.id].list) {
                        this.getData(cube);
                    }
                }
            }
            //test cubes remaining ribon/papper filtred by shop
            if(this.cubesStatusIntervalId) {
                clearInterval(this.cubesStatusIntervalId);
            }

            setTimeout(() => {
                this.testRemainingPages();
            }, 1000);

            this.cubesStatusIntervalId = setInterval(() => {
                this.testRemainingPages();
                // to test
                // if(this.cubesStatusIntervalId) {
                //     clearInterval(this.cubesStatusIntervalId);
                // }
            }, 5000);
        },
        testRemainingPages () {//BZDURA !!!!
            let currentPage = this.$refs.vuetable.tablePagination.current_page;

            let cubesPages = {};
            for (let row in this.$refs.vuetable.tableData) {
                let storeId = this.$refs.vuetable.tableData[row].id;

                //this.$set(this.$refs.vuetable.tableData[row], 'pages', undefined);

                if(this.cubes[storeId] && this.cubes[storeId].list) {

                    for(let cube of this.cubes[storeId].list) {
                        if(!this.cubesStatus[cube.name]) {
                            break;
                        }
                        let {pages = undefined, media = undefined, timestamp = undefined, error = undefined} = this.cubesStatus[cube.name];

                        if(pages < 0 || error) {
                            this.$set(this.$refs.vuetable.tableData[row], 'pages', 'error');
                            break;
                        } else if((media === '6x8' && pages < 50) || (media !== '6x8' && pages < 25) ) {
                            this.$set(this.$refs.vuetable.tableData[row], 'pages', 'low');
                            break;
                        } else {
                            this.$set(this.$refs.vuetable.tableData[row], 'pages', 'ok');
                        }
                    }
                }
            }

            this.$nextTick(() => {
                this.$refs.vuetable.gotoPage(currentPage);
            });
        },
        getData (cube) {
            this.emitWithKey('update-envs', {
                context: cube.context,
                data: {
                    media: true,
                    cubename: 'cubestatus:' + cube.name
                }
            });
        },
        emitWithKey (method, data) {
            data.data.key = '8FD71A527448';
            data.state = '';
            this.$socket.client.emit(method, data);
        },
        generateOptions (len){
            const result = [];
            const temp = [{
                name: '10',
                value: 10
            }, {
                name: '100',
                value: 100
            }];
            const all = { name: 'all', value: len };
            for(const o in temp){
                if(len % temp[o].value > 0){
                    if(this.perPageA === temp[o].value){
                        this.perPageA = temp[o].value;
                    }
                    result.push(temp[o]);
                }
            }
            if(result.length > 0){
                result.push(all);
            }
            this.limitOptions = result;
        },
        //USUNAC TO WSZYSTKO TO NIE TO MIEJSCE
        clicked (event) {
            this.$emit('clicked', event);
        },
        onSearch (target) {
            this.$emit('onSearch', this.filters);
        },
        onPaginationData (page) {
            this.$refs.pagination.setPaginationData(page);
        },
        onChangePage (page) {
            this.$emit('currentPage', page);
            this.$refs.vuetable.changePage(page);
        },
        dataManager (sortOrder, pagination) {
            this.$emit('sortUpdate');
            const searchParams = this.filters;
            let local = this.dataTable;
            if(sortOrder.length > 0) {
                local = orderBy(
                    local,
                    sortOrder[0].sortField,
                    sortOrder[0].direction
                );
            }

            const paginationNew = this.$refs.vuetable.makePagination(
                local.length,
                this.perPageA
            );
            this.showPag = this.perPageA > local.length;
            let from = pagination.from - 1;
            let to = from + this.perPageA;
            return {
                showPagination: true, //TO SHOW
                pagination: paginationNew,
                data: slice(local, from, to)
            };
        }
    }
};
</script>
